module.exports = __webpack_public_path__ + "img/ic_dashboard_live.35bc8263.svg";